export default __webpack_public_path__ + "static/media/Unfair-logo.623d9758.png";